var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5V10H22.5V7.5C22.5 4.76562 20.2344 2.5 17.5 2.5C14.6875 2.5 12.5 4.76562 12.5 7.5ZM10 12.5H3.75C3.04688 12.5 2.5 13.125 2.5 13.75V32.5C2.5 35.3125 4.6875 37.5 7.5 37.5H27.5C30.2344 37.5 32.5 35.3125 32.5 32.5V13.75C32.5 13.125 31.875 12.5 31.25 12.5H25V18.75C25 19.4531 24.375 20 23.75 20C23.0469 20 22.5 19.4531 22.5 18.75V12.5H12.5V18.75C12.5 19.4531 11.875 20 11.25 20C10.5469 20 10 19.4531 10 18.75V12.5ZM10 10V7.5C10 3.35938 13.3594 0 17.5 0C21.6406 0 25 3.35938 25 7.5V10H31.25C33.2812 10 35 11.7188 35 13.75V32.5C35 36.6406 31.6406 40 27.5 40H7.5C3.35938 40 0 36.6406 0 32.5V13.75C0 11.7188 1.64062 10 3.75 10H10Z",
    fill: "#EC842D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.367ce3d7eafad790ff2618d7c8744a35.svg";
export { ForwardRef as ReactComponent };